import React from 'react';
import {createBrowserHistory} from 'history';
import fetch from 'cross-fetch';
import {addResourceStrings} from '../util/translationUtility';
import {buildQueryString,} from './Infrastructure/urlBuilder';
import {buildStateFromModel,} from './Infrastructure/modelBuilder';
import {trackClick} from './Infrastructure/find';
import MobileFacets from './Features/Facets/MobileFacets';
import SearchResults from './components/SearchResults';
import WithLoading from './components/WithLoading';
import {updateState} from './Infrastructure/state';

import * as Attributes from './Infrastructure/attributes';
import * as Pagination from './Infrastructure/pagination';

import ProductTileWithVariationsContainer from './Features/Products/ProductTileWithVariationsContainer';
import SolutionTileContainer from './Features/Solutions/SolutionTileContainer';
import ArticleSearchResultsContainer from './Features/Articles/ArticleSearchResultsContainer';
import NeoCenterListingContainer from './Features/NeoCenterListingPage/NeoCenterListingContainer';
import {onProductSearchResultsUpdate, onSolutionResultsUpdated} from './Infrastructure/gtm';
import {ARTICLES, PRODUCTS} from "./constants";

import AddToModal from '../addtoshoppinglist/AddToModal';
import LoginModal from '../util/loginModalClient';
import truncateUtility from '../util/truncateUtility';
import { sendFilterDataToDataLayer, sendSortingToDataLayer } from '../util/gtm';

function reactFindSearch(tileComponent, onResultsUpdate, resultType) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = buildStateFromModel({ ...props, resultType });
            this.containerRef = React.createRef();
            this.onAttributeChange = this.onAttributeChange.bind(this);
            this.onClearAttributes = this.onClearAttributes.bind(this);
            this.onCurrentItemsPerPageChange = this.onCurrentItemsPerPageChange.bind(this);
            this.onCurrentSortByChange = this.onCurrentSortByChange.bind(this);
            this.onCurrentPageIndexChange = this.onCurrentPageIndexChange.bind(this);
            this.onChangeView = this.onChangeView.bind(this);
            this.onResultClick = this.onResultClick.bind(this);
            this.onShowMobileFacetsChange = this.onShowMobileFacetsChange.bind(this);
            this.onShowMobileFacetsToggle = this.onShowMobileFacetsToggle.bind(this);
            this.onToggleFacetExpanded = this.onToggleFacetExpanded.bind(this);
            this.hasSearchString = this.hasSearchString.bind(this);
            this.onToggleShowMoreFacet = this.onToggleShowMoreFacet.bind(this);

            this.onResultsUpdate = onResultsUpdate;
            if (onResultsUpdate)
                this.callOnResultsUpdate(props)
            addResourceStrings(this.props.LocalizationItems);
            this.TileComponent =  WithLoading(SearchResults(tileComponent));
        }
        
        callOnResultsUpdate = (searchResults) => {
            var listName = "Search";
            if (this.props.IsCategoryPage) {
                listName = this.props.GtmCategoryName;
            }
            this.onResultsUpdate(searchResults, listName);
        }

        componentDidMount() {
            require('./SearchApp.css');

            this.history = createBrowserHistory();
            this.history.listen((location, action) => {
                if (location.state && location.state.view) {
                    this.setState({ view: location.state.view });
                }
                this.fetchProductsUsingUrl(location.search);
            });
        }

        componentDidUpdate() {
            truncateUtility.truncate();
        }

        updateSearchResults(searchResults) {
            this.setState({
                ...updateState(this.state, searchResults, this.props.ContainerData.UseLoadMoreButton),
                isLoading: false,
            });
            if (this.onResultsUpdate) {
                this.callOnResultsUpdate(searchResults);
            }
        }

        updateUrl(state, useReplace = false) {
            const queryString = buildQueryString(state);
            // Going to let history listener take care of it
            if (useReplace) {
                this.history.replace({
                    search: queryString,
                    state: { state: state }
                });
            } else {
                this.history.push({
                    search: queryString,
                    state: { state: state }
                });
            }

            // TODO: Move this logic to fe if possible or remove it if the relevant code has all been removed
            var loginLinks = [...document.getElementsByClassName("js-updating-login-link")];
            loginLinks.forEach((e, i) => {
                var loginUrl = new URL(e.href);
                var params = new URLSearchParams(loginUrl.search);
                params.set('ReturnUrl', window.location.pathname + window.location.search);
                loginUrl.search = params.toString();
                e.href = loginUrl;
            });
        }

        fetchProductsUsingUrl(queryString, afterFunction) {
            if (this.contentLinkId) {
                if (queryString && queryString.indexOf("?") > -1) {
                    queryString = `${queryString}&contentLinkId=${this.contentLinkId}`;
                }
                else {
                    queryString = `?contentLinkId=${this.contentLinkId}`;
                }
            }
            this.setState({ isLoading: true });
            const url = `${this.props.ApiEndpoint}${queryString}`;
            fetch(url, { credentials: 'same-origin' })
                .then(response => response.json())
                .then(result => this.updateSearchResults(result))
                .then(result => !!afterFunction && afterFunction());
        }

        onCurrentSortByChange(requestedSortBy) {
            let pagination = Pagination.updateSortBy(this.state.pagination, requestedSortBy);
            if (this.props.ContainerData.UseLoadMoreButton) {
                pagination = Pagination.changePageIndex(pagination, 0);
            }

            this.updateUrl({
                ...this.state,
                pagination: pagination
            });
            sendSortingToDataLayer(requestedSortBy);
        }

        onCurrentItemsPerPageChange(requestedItemsPerPage) {
            this.updateUrl(
                {
                    ...this.state,
                    pagination: Pagination.changeItemsPerPage(this.state.pagination, requestedItemsPerPage)
                }
            );
        }

        onCurrentPageIndexChange(requestedPageIndex) {
            this.updateUrl(
                {
                    ...this.state,
                    pagination: Pagination.changePageIndex(this.state.pagination, requestedPageIndex)
                },
                this.props.ContainerData.UseLoadMoreButton // Don't push a new state unless actually switching pages
            );

            if (!this.props.ContainerData.UseLoadMoreButton) {
                this.scrollToTop();
            }
        }

        onAttributeChange(name, value) {
            const newOptions = {
                ...this.state,
                attributes: Attributes.toggleAttribute(this.state.attributes, name, value),
                pagination: Pagination.changePageIndex(this.state.pagination, 0)
            };
            this.updateUrl(newOptions);
            if(newOptions.attributes.find(obj => obj.name==name)?.values.find(val => val.name==value && val.checked)!=undefined){    
                sendFilterDataToDataLayer(name, value);
            }
        }

        onLoadMoreOrPrevious = (loadPrevious = false) => {
            if (loadPrevious) {
                // When loading previous, load the results, but don't update the url.
                var loadPreviousStateForQueryString = {
                    ...this.state,
                    pagination: Pagination.changePageIndex(this.state.pagination, this.state.paginationLowestPageIndex - 1)
                };
                const queryString = buildQueryString(loadPreviousStateForQueryString);

                //const container = this.containerRef.current;
                //const containerBottom = container.getBoundingClientRect().bottom;

                //this.fetchProductsUsingUrl(queryString, () => this.scrollToPrevious(containerBottom));

                this.fetchProductsUsingUrl(queryString);
            } else {
                this.onCurrentPageIndexChange(this.state.pagination.currentPageIndex + 1);
            }
        }

        onClearAttributes() {
            const newOptions = {
                ...this.state,
                attributes: Attributes.clearAttributes(this.state.attributes),
                pagination: Pagination.changePageIndex(this.state.pagination, 0)
            };
            this.updateUrl(newOptions);
        }

        /**
         * Updates current view (Products vs Articles)
         * @param {string} view Current View name.
         * @returns {void}
         */
        onChangeView(view) {
            const changes = { view: view };
            const newOptions = { ...this.state, ...changes };
            this.updateUrl(newOptions);
        }

        /**
         * Tracking for Find
         * @param {string} hitId HitId for Find result.
         * @returns {Promise}
         */
        onResultClick(hitId) {
            // Call tracking api
            if (typeof this.state.findClickTrackingViewModel !== "undefined") {
                const { TrackId, TwoLetterLanguageCode, SiteDefinitionId, ClickTrackingApiEndpoint, SearchTerm } = this.state.findClickTrackingViewModel;
                return trackClick(ClickTrackingApiEndpoint, hitId, TrackId, TwoLetterLanguageCode, SiteDefinitionId, SearchTerm);
            }
            return Promise.resolve();
        }

        onShowMobileFacetsChange(showMobileFacets) {
            this.setState({ showMobileFacets });
        }

        onShowMobileFacetsToggle() {
            const { showMobileFacets } = this.state;
            this.setState({ showMobileFacets: !showMobileFacets });
        }

        onToggleFacetExpanded(facetName) {

            this.setState({
                attributes: Attributes.toggleExpandAttribute(
                    this.state.attributes,
                    facetName
                )
            });

        }

        onToggleShowMoreFacet(facetName) {
            this.setState({
                attributes: Attributes.toggleShowMoreAttribute(
                    this.state.attributes,
                    facetName
                )
            });
        }


        hasSearchString() {
            const { searchString } = this.state;
            return searchString && searchString.length > 0;
        }

        getHeaderHeight = () => {
            const defaultHeaderHeight = 192;
            var header = document.getElementById('header');
            var headerHeight = header != null ? header.offsetHeight : defaultHeaderHeight;
            return headerHeight;
        }

        scrollToPrevious = (previousBottom) => {
            const container = this.containerRef.current;
            const containerBottom = container.getBoundingClientRect().bottom;
            const offset = containerBottom - previousBottom;
            window.scrollTo({ top: window.pageYOffset + offset });
        }

        scrollToTop = () => {
            const container = this.containerRef.current;
            const containerOffset = container.getBoundingClientRect().top;
            window.scrollTo({ top: window.pageYOffset + containerOffset - this.getHeaderHeight(), behavior: "smooth" });
        }

        updateLists = (newLists) => {
            this.setState((prevState) => {
                return {
                    wishlistData: {
                        ...prevState.wishlistData,
                        Wishlists: newLists
                    }
                };
            });
        }

        toggleAddToListModal = (isOpen, variation = null, isLoggedIn = true) => {
            if (isLoggedIn) {

                if (!this.state.wishlistsInitialized) {
                    this.setState({ wishlistsLoading: true });

                    fetch(this.state.wishlistData.GetWishlistsEndpoint)
                        .then(response => {
                            if (response.ok) {
                                return response.json();
                            } else {
                                throw new Error('Something went wrong');
                            }
                        })
                        .then(result => {
                            this.updateLists(result.Wishlists);
                            this.setState({
                                wishlistsLoading: false,
                                wishlistsInitialized: true,
                            });
                        })
                        .catch((e) => {
                            console.error("Unexpected error fetching wishlists.");
                            this.setState({
                                wishlistsLoading: false,
                            });
                        });
                }

                this.setState({
                    addToListVariation: variation,
                    addToListModalIsOpen: isOpen
                });
            } else {
                LoginModal.displayLoginModal();   
            }
        }

        setAddToListLinkClass = (linkClass, variationCode) => {
            this.setState((prevState) => {
                let results = [...prevState.results];
                let found = false;
                let index = 0;
                for (let i = 0; i < results.length; i++) {
                    for (let o = 0; o < results[i].Variations.length; o++) {
                        if (results[i].Variations[o].Code === variationCode) {
                             // deep copy variant to change object reference and force rerender of PureComponent for just this variant
                            let variant = Object.assign({}, results[i].Variations[o]);
                            variant.addToListLinkClass = linkClass;
                            results[i].Variations[o] = variant;
                            found = true;
                            index = i;
                            break;
                        }
                    }
                    if (found) break;
                }
                if (found) {
                    // deep copy variants to change array reference and force rerender of PureComponent for just this product
                    results[index].Variations = results[index].Variations.map(x => x);
                }
                return {
                    results: results
                };
            })
        }

        render() {
            const {
                isLoading,
                showMobileFacets,
                attributes,
                results,
                pagination,
                paginationFirstItemIndex,
                additionalBlocks,
                wishlistData,
                addToListModalIsOpen
            } = this.state;

            const isFiltered = Attributes.selectedAttributes(attributes).length > 0;

            const TileComponent = this.TileComponent;

            const addToListVariation = !!this.state.addToListVariation
                ? this.state.addToListVariation
                : {};

            return (
                <div className="search-app" ref={this.containerRef}>
                    { attributes &&
                        <MobileFacets
                            attributes={attributes}
                            onAttributeChange={this.onAttributeChange}
                            onClearAttributes={this.onClearAttributes}
                            showMobileFacets={showMobileFacets}
                            onShowMobileFacetsChange={this.onShowMobileFacetsChange}
                            onToggleFacetExpanded={this.onToggleFacetExpanded}
                            onToggleShowMoreFacet={this.onToggleShowMoreFacet}
                        />
                    }
                    <div className="search-app-inner row">
                        <div className="container">
                            <TileComponent
                                // results
                                results={results}
                                onResultClick={this.onResultClick}
                                additionalBlocks={additionalBlocks}
                                isFiltered={isFiltered}

                                isLoading={isLoading}

                                // pagination
                                pagination={pagination}
                                paginationFirstItemIndex={paginationFirstItemIndex}
                                onCurrentItemsPerPageChange={this.onCurrentItemsPerPageChange}
                                onCurrentSortByChange={this.onCurrentSortByChange}
                                onCurrentPageIndexChange={this.onCurrentPageIndexChange}
                                onShowMobileFacetsToggle={attributes ? this.onShowMobileFacetsToggle : undefined}
                                onLoadMoreOrPrevious={this.onLoadMoreOrPrevious}

                                // attributes 
                                attributes={attributes}
                                onAttributeChange={this.onAttributeChange}
                                onClearAttributes={this.onClearAttributes}
                                onToggleShowMoreFacet={this.onToggleShowMoreFacet}
                                onToggleFacetExpanded={this.onToggleFacetExpanded}

                                // additional data
                                containerData={this.props.ContainerData}
                                addToCartEndPoint={this.props.AddToCartEndPoint}
                                loginPageUrl={this.props.LoginPageUrl}
                                isUserLoggedIn={this.props.IsUserLoggedIn}
                                isOrderRequestOnlyMarket={this.props.IsOrderRequestOnlyMarket}

                                wishlistData={this.state.wishlistData}
                                updateLists={this.updateLists}
                                toggleAddToListModal={this.toggleAddToListModal}

                                resultType={resultType}
                                isCategoryPage={this.props.IsCategoryPage}
                                customerServiceTextAndLink={this.props.CustomerServiceTextAndLink}
                            />
                        </div>
                    </div>

                    {resultType === PRODUCTS &&
                        <AddToModal
                            Lists={wishlistData.Wishlists}
                            UpdateLists={this.updateLists}
                            Name={addToListVariation.Name}
                            ImageUrl={addToListVariation.WishlistImageUrl}
                            Code={addToListVariation.Code}
                            SKU={addToListVariation.SKU}
                            ModalIsOpen={addToListModalIsOpen}
                            IsLoading={this.state.wishlistsLoading}
                            ToggleModal={this.toggleAddToListModal}
                            AddItemEndpoint={wishlistData.AddItemEndpoint}
                            CreateListEndpoint={wishlistData.AddListEndpoint}
                            SetLinkClass={(linkClass) => this.setAddToListLinkClass(linkClass, addToListVariation.Code)}
                            SetSrText={() => { }}
                            SetLinkText={() => { }}
                            ProductVariation={addToListVariation}
                        />}
                </div>
            );
        }
    }
}

export const ProductSearch = reactFindSearch(ProductTileWithVariationsContainer, onProductSearchResultsUpdate, PRODUCTS);
export const SolutionSearch = reactFindSearch(SolutionTileContainer, onSolutionResultsUpdated, PRODUCTS);
export const ArticleSearch = reactFindSearch(ArticleSearchResultsContainer, null, ARTICLES);
export const NeoCenterListingPage = reactFindSearch(NeoCenterListingContainer);
